import { render } from "./edit.vue?vue&type=template&id=35205ebd&scoped=true"
import script from "./edit.vue?vue&type=script&lang=js"
export * from "./edit.vue?vue&type=script&lang=js"

import "./edit.vue?vue&type=style&index=0&id=35205ebd&scoped=true&lang=css"

import exportComponent from "F:\\Program\\JAVA\\JavaProject\\DXD物流系统\\logisticsWeb\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35205ebd"]])

export default __exports__